import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlatformSettingsService from "../services/platformSetting.service";

const initialState = {
    domains: [],
    mailers: [],
    isFetching: false,
    isSuccess: false,
    error: false,
};

export const fetchPlatformDomains = createAsyncThunk(
    "platform-settings/domains",
    async () => {
        const response = await PlatformSettingsService.fetchDomains();
        return response;
    }
);

export const fetchPlatformMailers = createAsyncThunk(
    "platform-settings/mailers",
    async () => {
        const response = await PlatformSettingsService.fetchMailers();
        return response;
    }
);

export const addDomain = createAsyncThunk(
    "platform-settings/domain/add",
    async (data) => {
        const response = await PlatformSettingsService.addDomain(data);
        return response;
    }
);

export const addMailer = createAsyncThunk(
    "platform-settings/mailer/add",
    async (data) => {
        const response = await PlatformSettingsService.addMailer(data);
        return response;
    }
);


export const updateDomain = createAsyncThunk(
    "platform-settings/domain/update",
    async ({ id, data }) => {
        const response = await PlatformSettingsService.updateDomain(id, data);
        return response;
    }
);

export const updateMailer = createAsyncThunk(
    "platform-settings/mailer/update",
    async ({ id, data }) => {
        const response = await PlatformSettingsService.updateMailer(id, data);
        return response;
    }
)

const PlatformSettingSlice = createSlice({
    name: "CompaniesManager",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchPlatformDomains.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.domains = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(fetchPlatformDomains.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(fetchPlatformDomains.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });

        builder.addCase(fetchPlatformMailers.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.mailers = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(fetchPlatformMailers.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(fetchPlatformMailers.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });


        builder.addCase(addMailer.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.mailers = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(addMailer.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(addMailer.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });

        builder.addCase(addDomain.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.domains = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(addDomain.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(addDomain.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });


        builder.addCase(updateMailer.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.mailers = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(updateMailer.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(updateMailer.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });

        builder.addCase(updateDomain.fulfilled, (state, action) => {
            const { data } = action.payload;
            state.domains = data;
            state.isSuccess = true;
            state.isFetching = false;
            state.error = false;
        });
        builder.addCase(updateDomain.pending, (state) => {
            state.isSuccess = false;
            state.isFetching = true;
            state.error = false;
        });
        builder.addCase(updateDomain.rejected, (state) => {
            state.isSuccess = false;
            state.isFetching = false;
            state.error = true;
        });
    },
});

export default PlatformSettingSlice;
